import { render, staticRenderFns } from "./TrashCanItem.vue?vue&type=template&id=4b419b7d&scoped=true&"
import script from "./TrashCanItem.vue?vue&type=script&lang=ts&"
export * from "./TrashCanItem.vue?vue&type=script&lang=ts&"
import style0 from "./TrashCanItem.vue?vue&type=style&index=0&id=4b419b7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b419b7d",
  null
  
)

export default component.exports